<div class="create-order">
	<div class="top">
		<app-order-book [orderBook]="liveTicker()?.orderBook" />
	</div>

	@if (form) {
		<form
			class="form"
			[formGroup]="form"
		>
			<div class="top">
				<app-trade-side-toggle
					[side]="form.get('side')?.value"
					(sideChange)="toggleTypeDeal($event)"
				/>

				<div class="settings">
					<app-order-type-select
						[control]="form.get('type')"
						[types]="orderTypes"
					/>

					<app-order-term-select
						[control]="form.get('time_in_force')"
						[terms]="isVisibleTrailingStop ? trailingStopTerms : orderTerms"
					/>

					@if (isVisibleStopPrice) {
						<app-order-price-input
							label="createOrder.stopPrice"
							[control]="form.get('stop_price')"
						/>
					}

					@if (isVisibleLimitPrice) {
						<app-order-price-input
							label="createOrder.limitPrice"
							[control]="form.get('limit_price')"
						/>
					}

					@if (isVisibleTrailingStop) {
						<app-trailing-stop-controls
							[tickerPrice]="targetPrice()"
							(changeTrail)="onChangeTrail($event)"
						/>
					}

					<app-order-qty-input
						[control]="form.get('inputQty')"
						[isMaxDecimalCount]="true"
						[visibleQtySelect]="true"
						[activeQtyType]="form.get('activeQtyType')?.value"
						[availableQty]="position()?.qty ?? 0"
						[qty]="form.get('qty')?.value ?? 0"
						(qtyTypeChange)="setQtyType($event)"
					/>
				</div>

				@if (isVisibleSlTp() && !isVisibleTrailingStop) {
					<app-sl-tp-controls
						[isBuy]="form.get('side')?.value === orderSideEnum.BUY"
						[qty]="form.get('qty')?.value ?? 0"
						[targetPrice]="targetPrice()"
						[isActiveStopLoss]="isSlTpActive().stopLoss"
						[isActiveTakeProfit]="isSlTpActive().takeProfit"
						(changeActiveStopLoss)="toggleActiveSlTp('stop-loss', $event)"
						(changeActiveTakeProfit)="toggleActiveSlTp('take-profit', $event)"
						(changePriceStopLoss)="togglePriceSlTp('stop-loss', $event)"
						(changePriceTakeProfit)="togglePriceSlTp('take-profit', $event)"
					/>
				}
			</div>

			<div class="bottom">
				<div class="order-summary">
					<div class="item">
						<p class="label">{{ 'createOrder.amountTransaction' | translate }}:</p>
						<span class="value">{{ transactionAmount | price }}</span>
					</div>
					<div class="item">
						<p class="label">{{ 'createOrder.availableWithLeverage' | translate }}:</p>
						<span
							class="value"
							[appAnimatedNumber]="alpacaAccount()?.buying_power ?? 0 | price"
						></span>
					</div>
				</div>

				<app-button
					[appearance]="isActiveBuy ? 'positive' : 'negative'"
					size="m"
					type="submit"
					[isDisabled]="form.invalid"
					[isLoading]="isLoadingCreate()"
					(clicked)="createOrder()"
				>
					{{ (isActiveBuy ? 'createOrder.side.buy' : 'createOrder.side.sell') | translate }}
					{{ liveTicker()?.ticker }}
				</app-button>
			</div>
		</form>
	}
</div>
